import { useNavigate } from 'react-router-dom';
import {
  AuthLayout,
  AuthStepProgress,
  CompanyRegistrationForm,
} from '../components';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import { AUTH_SUBTITLE_CLASS, AUTH_TITLE_CLASS } from '../lib/authStyles';

export function CompanyRegistrationPage() {
  const navigate = useNavigate();

  const handleStepThreeSuccess = (data) => {
    if (data?.id) {
      localStorage.setItem('company_id', data.id);
    }
    if (data?.name) {
      localStorage.setItem('company_name', data.name);
    }
    localStorage.removeItem('register_step');
    navigate('/choose-integration');
  };

  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <div className="animate-fadeIn">
        <AuthStepProgress
          currentStep={2}
          totalSteps={2}
          stepTitle="Company Registration"
        />

        <h1 className={AUTH_TITLE_CLASS}>Registration Process</h1>

        <h2 className={AUTH_SUBTITLE_CLASS}>
          Provide your legal business details to configure your workspace
          environment.
        </h2>

        <CompanyRegistrationForm
          onBack={() => {
            localStorage.clear();
            window.location.href = '/login';
          }}
          onSuccess={handleStepThreeSuccess}
        />
      </div>
    </AuthLayout>
  );
}
